import type { UserDTO } from '@/shared/api/types/user-types'

/**
 * In-memory IAM fixtures shared across mock services. Mutations to these
 * arrays/maps are intentional — they let the UI feel real for the demo.
 * Replace with real network calls in `user-service.ts` when the backend lands.
 */

const TENANT_HERISTEP = '11111111-1111-1111-1111-111111111111'
const TENANT_OCEAN = '22222222-2222-2222-2222-222222222222'

export const mockUsers: UserDTO[] = [
  {
    id: 'u-001',
    tenantId: null,
    username: 'root.admin',
    email: 'root@heristep.io',
    fullName: 'Root Administrator',
    avatarUrl: null,
    phone: '+84 901 000 001',
    accountLevel: 'SUPER_ADMIN',
    isActive: true,
    createdAt: '2025-09-12T03:21:00Z',
  },
  {
    id: 'u-002',
    tenantId: TENANT_HERISTEP,
    username: 'minh.nguyen',
    email: 'minh.nguyen@heristep.io',
    fullName: 'Nguyễn Minh',
    avatarUrl: null,
    phone: '+84 901 000 002',
    accountLevel: 'TENANT_ADMIN',
    isActive: true,
    createdAt: '2025-11-04T08:10:00Z',
  },
  {
    id: 'u-003',
    tenantId: TENANT_HERISTEP,
    username: 'lan.tran',
    email: 'lan.tran@heristep.io',
    fullName: 'Trần Thị Lan',
    avatarUrl: null,
    phone: '+84 901 000 003',
    accountLevel: 'USER',
    isActive: true,
    createdAt: '2026-01-18T02:45:00Z',
  },
  {
    id: 'u-004',
    tenantId: TENANT_HERISTEP,
    username: 'duc.pham',
    email: 'duc.pham@heristep.io',
    fullName: 'Phạm Văn Đức',
    avatarUrl: null,
    phone: null,
    accountLevel: 'USER',
    isActive: false,
    createdAt: '2026-02-02T11:00:00Z',
  },
  {
    id: 'u-005',
    tenantId: TENANT_OCEAN,
    username: 'kelly.ho',
    email: 'kelly@ocean.travel',
    fullName: 'Kelly Ho',
    avatarUrl: null,
    phone: '+84 902 000 005',
    accountLevel: 'TENANT_ADMIN',
    isActive: true,
    createdAt: '2026-03-08T06:30:00Z',
  },
  {
    id: 'u-006',
    tenantId: TENANT_OCEAN,
    username: 'long.le',
    email: 'long@ocean.travel',
    fullName: 'Lê Hoàng Long',
    avatarUrl: null,
    phone: null,
    accountLevel: 'USER',
    isActive: true,
    createdAt: '2026-04-21T09:15:00Z',
  },
  {
    id: 'u-007',
    tenantId: null,
    username: 'support.bot',
    email: null,
    fullName: 'Support Service Account',
    avatarUrl: null,
    phone: null,
    accountLevel: 'USER',
    isActive: true,
    createdAt: '2026-05-01T01:00:00Z',
  },
  {
    id: 'u-008',
    tenantId: TENANT_HERISTEP,
    username: 'hoa.dang',
    email: 'hoa.dang@heristep.io',
    fullName: 'Đặng Thị Hoa',
    avatarUrl: null,
    phone: '+84 901 000 008',
    accountLevel: null,
    isActive: false,
    createdAt: '2026-05-15T04:20:00Z',
  },
]

/** Tiny delay so React Query loading states render in the mockup. */
export async function mockDelay(ms = 200): Promise<void> {
  await new Promise((resolve) => setTimeout(resolve, ms))
}
